

const sendPostMessage = (eventCategory: string, eventAction: string, eventLabel: string) => {
    const track = {
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel
    }
    if (window.parent) {
        window.parent.postMessage(track, "*");
    }
};

export default sendPostMessage;
